var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8327 54.6673C9.3431 54.6673 8.06838 54.1374 7.00852 53.0775C5.94865 52.0177 5.41782 50.742 5.41602 49.2507V16.7507C5.41602 15.2611 5.94685 13.9863 7.00852 12.9265C8.07018 11.8666 9.3449 11.3358 10.8327 11.334H24.8483C25.5705 11.334 26.2593 11.4694 26.9148 11.7402C27.5702 12.0111 28.1453 12.3947 28.64 12.8913L32.4993 16.7507H56.8743C57.6417 16.7507 58.2854 17.0107 58.8054 17.5307C59.3254 18.0507 59.5845 18.6934 59.5827 19.459C59.5809 20.2245 59.3209 20.8682 58.8027 21.39C58.2845 21.9118 57.6417 22.1709 56.8743 22.1673H21.2598C18.4612 22.1673 16.0237 23.0475 13.9473 24.8079C11.8709 26.5684 10.8327 28.8027 10.8327 31.5111V49.2507L16.1816 31.4434C16.5428 30.2698 17.209 29.3336 18.1804 28.6348C19.1518 27.9361 20.2234 27.5858 21.3952 27.584H56.3327C58.1834 27.584 59.6396 28.3179 60.7012 29.7859C61.7629 31.2538 62.0446 32.8445 61.5462 34.5579L56.6712 50.8079C56.3101 51.9816 55.6448 52.9186 54.6752 53.6192C53.7056 54.3198 52.6331 54.6691 51.4577 54.6673H10.8327Z",
    fill: "url(#paint0_linear_11174_7117)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11174_7117",
    x1: 5.41602,
    y1: 33.0007,
    x2: 61.785,
    y2: 33.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58447"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.c990387b6684d2c44c396c88aec7d3b0.svg";
export { ForwardRef as ReactComponent };